import React from 'react'

import { SxProps } from '@mui/material'

import Box from 'components_new/atoms/Box'
import Grid from 'components_new/atoms/Grid'
import Skeleton from 'components_new/atoms/Skeleton'

import { METRIC_PREVIEW_HEIGHT } from '../MetricPreview'

interface Props {
  sx?: SxProps
}

const Loading = (props: Props) => {
  const { sx } = props

  return (
    <Box sx={sx}>
      <Grid container={true} spacing={2} sx={{ mb: 6 }}>
        <Grid item={true} xs={12} sm={6}>
          <Skeleton height={METRIC_PREVIEW_HEIGHT} variant="rounded" />
        </Grid>
        <Grid item={true} xs={12} sm={6}>
          <Skeleton height={METRIC_PREVIEW_HEIGHT} variant="rounded" />
        </Grid>
      </Grid>

      <Skeleton height={128} sx={{ mb: 6 }} />

      <Grid container={true} spacing={2}>
        <Grid item={true} xs={12} sm={6}>
          <Skeleton height={METRIC_PREVIEW_HEIGHT} variant="rounded" />
        </Grid>
        <Grid item={true} xs={12} sm={6}>
          <Skeleton height={METRIC_PREVIEW_HEIGHT} variant="rounded" />
        </Grid>
      </Grid>
    </Box>
  )
}

Loading.displayName = 'Loading'

export default Loading
